import { useState } from "react";
import { X } from "lucide-react";
import { btnGold, btnGhost, inp, lbl } from "./ui";

const today = () => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`; };

export default function EventForm({ initial, types, defaults, onSave, onClose }) {
  const [f, setF] = useState(() => ({
    name: "", type: types[0], custom_type: "", date: today(), start_time: "10:00", venue: "",
    ...initial,
    categories: (initial?.categories?.map((c) => c.label) || defaults).join("\n"),
    zones: (initial?.zones?.map((z) => z.name) || ["Main hall"]).join("\n"),
  }));
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const lines = (s) => s.split(/\n|,/).map((x) => x.trim()).filter(Boolean);
  const submit = (e) => {
    e.preventDefault();
    onSave({ name: f.name, type: f.type, custom_type: f.type === "Other" ? f.custom_type : "", date: f.date, start_time: f.start_time,
      venue: f.venue, categories: lines(f.categories), zones: lines(f.zones) });
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/80 backdrop-blur-sm flex items-start justify-center overflow-y-auto p-4" data-testid="att-event-form">
      <form onSubmit={submit} className="w-full max-w-2xl bg-[#111] border border-white/10 rounded-xl p-6 lg:p-8 my-8">
        <div className="flex justify-between items-center mb-6">
          <h3 className="font-serif-display text-3xl text-white">{initial?.id ? "Edit event" : "New event"}</h3>
          <button type="button" onClick={onClose} aria-label="Close" className="text-neutral-400 hover:text-white"><X size={20} /></button>
        </div>
        <div className="grid sm:grid-cols-2 gap-4">
          <div className="sm:col-span-2"><label className={lbl}>Event name *</label><input required data-testid="att-ev-name" className={inp} value={f.name} onChange={set("name")} placeholder="Sunday Worship Service" /></div>
          <div><label className={lbl}>Type *</label><select data-testid="att-ev-type" className={inp} value={f.type} onChange={set("type")}>{types.map((t) => <option key={t}>{t}</option>)}</select></div>
          {f.type === "Other"
            ? <div><label className={lbl}>Custom type</label><input data-testid="att-ev-custom-type" className={inp} value={f.custom_type} onChange={set("custom_type")} placeholder="e.g. Youth Camp" /></div>
            : <div><label className={lbl}>Venue</label><input data-testid="att-ev-venue" className={inp} value={f.venue} onChange={set("venue")} /></div>}
          <div><label className={lbl}>Date *</label><input required type="date" data-testid="att-ev-date" className={inp} value={f.date} onChange={set("date")} /></div>
          <div><label className={lbl}>Start time</label><input type="time" data-testid="att-ev-time" className={inp} value={f.start_time} onChange={set("start_time")} /></div>
          {f.type === "Other" && <div className="sm:col-span-2"><label className={lbl}>Venue</label><input data-testid="att-ev-venue" className={inp} value={f.venue} onChange={set("venue")} /></div>}
          <div>
            <label className={lbl}>Counting categories (one per line)</label>
            <textarea rows={5} data-testid="att-ev-categories" className={inp} value={f.categories} onChange={set("categories")} />
          </div>
          <div>
            <label className={lbl}>Zones / departments (one per line)</label>
            <textarea rows={5} data-testid="att-ev-zones" className={inp} value={f.zones} onChange={set("zones")} />
            <p className="text-[11px] text-neutral-500 mt-1">Give each usher their own zone to avoid double-counting.</p>
          </div>
        </div>
        <div className="flex justify-end gap-3 mt-8">
          <button type="button" onClick={onClose} className={btnGhost}>Cancel</button>
          <button data-testid="att-ev-save" className={btnGold}>Save event</button>
        </div>
      </form>
    </div>
  );
}
